import React, { Suspense } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import AuthProtected from './AuthProtected';
import AdminRoute from './AdminRoute';
import PublicRoute from './PublicRoute';
import RouteErrorBoundary from '../Components/Common/RouteErrorBoundary';

const Index = () => {
    // Check if route is an admin route
    // /apps-chat: yonetici destek sohbeti (menude yalniz yoneticide); musteri adresi elle yazarsa /dashboard'a doner (guvenlik-3, 12 Eki 2026)
    const isAdminRoute = (path: string) => path.startsWith('/admin') || path === '/apps-chat';

    // Keyed by pathname so navigating away from a crashed page resets the
    // boundary (otherwise hasError would stay latched on the next route).
    const location = useLocation();

    return (
        <React.Fragment>
            <RouteErrorBoundary key={location.pathname}>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>}>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <PublicRoute restricted={route.path === '/login' || route.path === '/register'}>
                                    <NonAuthLayout>
                                        {route.component}
                                    </NonAuthLayout>
                                </PublicRoute>
                            }
                            key={idx}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                isAdminRoute(route.path) ? (
                                    <AdminRoute>
                                        <VerticalLayout>{route.component}</VerticalLayout>
                                    </AdminRoute>
                                ) : (
                                    <AuthProtected>
                                        <VerticalLayout>{route.component}</VerticalLayout>
                                    </AuthProtected>
                                )
                            }
                            key={idx}
                        />
                    ))}
                </Route>
            </Routes>
            </Suspense>
            </RouteErrorBoundary>
        </React.Fragment>
    );
};

export default Index;